<template>
  <el-table
    :data="tableData"
    v-loading="listLoading"
    border
    fit
    highlight-current-row
    style="width: 100%;"
    sortable="custom"
    :height="tableHeight"
    header-cell-class-name="table-header"
    :cell-style="tableRowStyle"
    :header-cell-style="tableHeaderColor"
    @selection-change="handleSelectionChange"
    @sort-change="sortChange"
    :row-key="getRowKeys"
    id="projectTab"
    ref="multipleTable"
  >
  <el-table-column type="selection" width="55" :reserve-selection="true" v-if="ischeckbox" />
  <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
        v-if="tableColumns.length>0"
      ></el-table-column>
    <template v-for="(column, index) in tableColumns">
      <template v-if="column.form_type === 'operation'">
        <el-table-column
          align="center"
          :prop="column.field"
          :label="column.name"
        >
         <template #default="scope">
           <el-button
            type="text"
            :icon="column1.icon"
            v-for="(column1, ind) in handleMenuBackes(column.sub_array,scope.row)"
            :key="ind"
            @click="handleEdit(ind,scope.$index)"
          >
            {{ column1.name }}
          </el-button>
         </template>
        </el-table-column>
      </template>
      <template v-else-if="column.children">
        <el-table-column
          :prop="column.field"
          :label="column.name"
          align="center"
        >
          <template v-for="(column1, index) in column.children">
            <tablecell :column="column1" />
          </template>
        </el-table-column>
      </template>
       <template v-else>
        <tablecell :column="column" :handlecellSelectBack="handletableSelectBack" />
      </template>
    </template>
  </el-table>
</template>
<script>
import tablecell from './tablecell.vue'
export default {
  components: { tablecell },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: 'success',
        1: 'info'
      }
      return statusMap[status]
    }
  },
  props: {
    tableColumns: {
      type: Array,
      default() {
        return []
      }
    },
    multipleSelection: {
      type: Array,
      default() {
        return []
      }
    },
    tableData: {
      type: Array,
      default() {
        return []
      }
    },
    listLoading: {
      type: Boolean,
      default: false
    },
    tableHeight: {
      type: Number,
      default: document.documentElement.clientHeight - 190
    },
    // 判断是否开启多选
    ischeckbox: {
      type: Boolean,
      default: false
    },
    getRowKeys: {
      type: Function
    },
    // 动态菜单回调
    handleMenuBack: {
      type: Function
    },
    // 排序回调
    sortChange: {
      type: Function
    },
    // 编辑回调
    handleEditCallBack: {
      type: Function
    },
    handletableSelectBack: {
      type: Function
    }
  },
  data() {
    return {
      handle_menu_isbool: false
    }
  },
  watch: {
    tableColumns: {
      handler: function(newVal) {
        console.log('数据数组内容=--=-=-=-' + JSON.stringify(newVal))
      }
    }
  },
  computed: {},
  methods: {
    handleMenuBackes(array, row) {
      if (this.handleMenuBack) {
        return array.concat(this.handleMenuBack(row))
      }
      return array
    },
    handleSelectionChange(val) {
      console.log('当前数组内容' + JSON.stringify(val))
      this.multipleSelection = val
    },
    handleEdit(index, row) {
      this.handleEditCallBack(index, this.tableData[row])
    },
    tableRowStyle({ row, rowIndex }) {
      return 'font-size:13px;color:black;'
    },
    // 设置表头行的样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#409EFF;color:#fff;font-wight:500;font-size:14px;text-align:center'
    }
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.listLoading = false
    }, 5000)
  }
}
</script>
<style>
.wrapper {
  color: #388138;
}
</style>



// WEBPACK FOOTER //
// src/components/Table/template1.vue